import { EditorExtensionEnum as t } from "../enums/editor-extensions-enum.mjs";
const i = [
  t.History,
  [
    t.Heading,
    t.FontFamily,
    t.FontSize,
    t.TextColor,
    t.TextBackgroundColor
  ],
  [
    t.Paragraph,
    t.LineHeight,
    t.Indent,
    t.TextAlign,
    t.Substitution
  ],
  [
    t.Bold,
    t.Italic,
    t.Underline,
    t.Strike,
    t.BulletList,
    t.OrderedList
  ],
  [t.Link, t.Image, t.SpecialCharacters]
];
export {
  i as semanticOrder
};
